import React from 'react';
import useVisitorTracking from '../hooks/useVisitorTracking';
import { useRegion } from '../contexts/RegionContext';
import { useLang } from '../contexts/LanguageContext';

const VisitorTracker = () => {
  const { code } = useRegion();
  const { lang } = useLang();
  useVisitorTracking(code, lang);
  return null;
};

export default VisitorTracker;
